import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "@vilocnv/allsetra-core";
import i18n from "i18next";
import { isEmpty } from "lodash";
import { getKeys } from "domain/keys/api/get-keys";
import { KeysRequestDto } from "domain/keys/entities/dtos/keys-request.dto";

export const getKeysAction = createAsyncThunk(
  "keys/getKeysAction",
  async ({ accountId }: KeysRequestDto) => {
    try {
      if (isEmpty(accountId)) {
        toast.error(i18n.t("errors.accounts.selectFirst"));
        return;
      }

      return await getKeys({ accountId });
    } catch (e: any) {
      console.error(e);
      throw new Error(e);
    }
  }
);
